import { datasource } from './datasource';

export const appUserDS = (databaseAlias, currentUserId, actions) => () =>
  datasource(databaseAlias, currentUserId, actions)('app_user', {
    model: {
      id: 'id',
      auditable: true,
      //                    syncable: true,
      byProshop: true,
      fields: {
        id: {
          type: 'string',
        },
        username: {
          type: 'string',
        },
        username_canonical: {
          type: 'string',
        },
        email: {
          type: 'number',
        },
        email_canonical: {
          type: 'string',
        },
        salt: {
          type: 'string',
        },
        password: {
          type: 'string',
        },
        last_login: {
          type: 'number',
        },
        locked: {
          type: 'string',
        },
        expired: {
          type: 'string',
        },
        expires_at: {
          type: 'string',
        },
        confirmation_token: {
          type: 'string',
        },
        password_requested_at: {
          type: 'string',
        },
        roles: {
          type: 'string',
        },
        credentials_expired: {
          type: 'string',
        },
        credentials_expire_at: {
          type: 'string',
        },
        firstname: {
          type: 'string',
        },
        lastname: {
          type: 'string',
        },
        telephone: {
          type: 'string',
        },
        address: {
          type: 'string',
        },
        country: {
          type: 'string',
        },
        state: {
          type: 'string',
        },
        city: {
          type: 'string',
        },
        postal_code: {
          type: 'string',
        },
        preferred_lang: {
          type: 'string',
        },
        created_at: {
          type: 'string',
        },
        updated_at: {
          type: 'string',
        },
      },
    },
  });
